module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', [_c('boy-three', {
    attrs: {
      "data": _vm.boyThreeData
    }
  }), _vm._v(" "), _c('girl-three', {
    attrs: {
      "data": _vm.girlThreeData
    }
  }), _vm._v(" "), _c('boy-four', {
    attrs: {
      "data": _vm.boyFourData
    }
  }), _vm._v(" "), _c('boy-one', {
    attrs: {
      "data": _vm.boyOneData
    }
  }), _vm._v(" "), _c('texter', {
    attrs: {
      "data": _vm.texterData
    }
  }), _vm._v(" "), _c('player-one', {
    attrs: {
      "data": _vm.playerOneData
    }
  }), _vm._v(" "), _c('girl-two', {
    attrs: {
      "data": _vm.girlTwoData
    }
  }), _vm._v(" "), _c('player-two', {
    attrs: {
      "data": _vm.playerTwoData
    }
  }), _vm._v(" "), _c('girl-one', {
    attrs: {
      "data": _vm.girlOneData
    }
  }), _vm._v(" "), _c('hailey-background', {
    attrs: {
      "data": _vm.haileyBackgroundData
    }
  }), _vm._v(" "), _c('reece-background', {
    attrs: {
      "data": _vm.reeceBackgroundData
    }
  }), _vm._v(" "), _c('player-three', {
    attrs: {
      "data": _vm.playerThreeData
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9c7cb12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_6/svg/backgroundCharacters/backgroundCharacters.vue
// module id = 993
// module chunks = 1